import { useState, useCallback } from 'react';
import * as districtManagementAction from "../redux/store/district-management/district.store";

export const useLookupDistrict = () => {
    const [district, setDistrict] = useState([]);

    const getLookupDistrict = useCallback(async () => {
        try {
            const res = await districtManagementAction.GetLookupDistrict();
            if (res && res.content) {
                setDistrict(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { district, getLookupDistrict };
};
